import { BaseElementDef, BaseElementDefBase } from "./BaseElementDef";
//import { map, first } from "rxjs/operators";
import { FormItem } from "@cs/FormItem";
import { FormDefinitionItem } from "./__DefinitionDataInterface";
import { CaptchaBehaviorSettings } from "@cs-ts/captcha-behavior-settings";
import { CalculationContext } from "./__CalculationContextInterface";

export interface FormCaptchaItem extends FormItem {
    captchaToken: string;
}

export default class CaptchaBehaviorDef extends BaseElementDef<CaptchaBehaviorSettings, FormDefinitionItem<CaptchaBehaviorSettings>, FormItem> {
    captchaToken: string | null;

    constructor(parentElement: BaseElementDefBase | null, elementData: FormItem, definitionData: FormDefinitionItem<CaptchaBehaviorSettings>, calculationContext: CalculationContext) {
        super(parentElement, elementData, definitionData, calculationContext);
        this.captchaToken = null;
    }

    setCaptchaToken(token: string) {
        this.captchaToken = token;
    }

    getData(excludeChildren: boolean) {
        const result = super.getData(excludeChildren) as FormCaptchaItem;
        if (result != null && this.captchaToken != null) {
            result.captchaToken = this.captchaToken;
        }
        return result;
    }
}
